import { useState } from "react";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";
import { API, errMsg } from "@/lib/api";
import { Cloud } from "@/components/site/Decor";

export const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("admin_token", data.token);
      onLogin(data.user);
    } catch (e2) { setErr(errMsg(e2)); } finally { setLoading(false); }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-b from-sky-100 to-white p-4">
      <Cloud className="drift absolute left-[-40px] top-16 w-56 text-white" />
      <Cloud className="drift absolute bottom-20 right-[-30px] w-48 text-white" />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-[2rem] bg-white p-8 shadow-xl ring-1 ring-sky-100" data-testid="admin-login-form">
        <img src="/images/clinic-logo.jpg" alt="" className="h-14 w-14 rounded-full" />
        <h1 className="font-display mt-4 text-3xl font-semibold text-blue-900">Website Admin</h1>
        <p className="mt-1 text-sm text-slate-600">Sign in to update your clinic website.</p>
        <label className="mt-6 block text-sm font-semibold text-slate-700">Email</label>
        <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100" />
        <label className="mt-4 block text-sm font-semibold text-slate-700">Password</label>
        <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100" />
        {err && <p className="mt-3 rounded-xl bg-red-50 px-3 py-2 text-sm text-red-600" data-testid="login-error">{err}</p>}
        <button data-testid="login-submit-btn" disabled={loading} className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-blue-900 px-6 py-3.5 font-semibold text-white transition-colors hover:bg-blue-800 disabled:opacity-60">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Sign in
        </button>
      </form>
    </div>
  );
};
